module.exports = __webpack_public_path__ + "img/logo-full.8b045e6.svg";